import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import DeliveryPerson from "../../entities/DeliveryPerson";
import {DeliveryPersonService} from "../../service/DeliveryPersonService";
import Balance from "../../entities/Balance";

class DeliveryPersonStore {

    public persons: DeliveryPerson[];
    public pagination: Pagination;
    public filter?: string;
    public totalBalances: Balance[];
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.persons = [];
        this.totalBalances = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            persons: observable,
            pagination: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.persons.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await DeliveryPersonService.get(page, pageSize, this.filter, [], true);
        if (response.success) {
            runInAction(() => {
                this.persons = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

    @action
    public async getTotalBalances(): Promise<void> {
        const response = await DeliveryPersonService.getTotalBalances();
        if (response.success) {
            runInAction(() => {
                this.totalBalances = response.data || [];
            })
        }
        this.commonStore.processErrors(response);
    }

}

export default DeliveryPersonStore;